import { BarProps } from './types';

type CalcBarWidthParams = Pick<
  BarProps,
  'data' | 'xScale' | 'xSelect' | 'maxWidth'
>;

export const calculateBarWidth = ({
  data,
  xScale,
  xSelect,
  maxWidth,
}: CalcBarWidthParams) => {
  const widths = data.map((_, index) => {
    const isLastItem = index === data.length - 1;
    if (isLastItem) {
      return Infinity;
    }
    return xScale(xSelect(data[index + 1])) - xScale(xSelect(data[index]));
  });
  return Math.min(...widths, maxWidth);
};
